var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRewardsAll = function SvgRewardsAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M0 0h40v41H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#RewardsAll_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1003-731H437v3954h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1003-130H437v482h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#RewardsAll_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -34,
    width: 381,
    height: 290,
    rx: 10,
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 20,
    fill: "#03C8B0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__c",
    maskUnits: "userSpaceOnUse",
    x: 10.734,
    y: 11.008,
    width: 7,
    height: 6,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.734 11.008h7v6h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.252 16.455a8.888 8.888 0 0 1 4.175-3.931c.139-.063.172-.261.1-.382-.082-.142-.243-.164-.382-.1a9.378 9.378 0 0 0-4.376 4.131c-.168.318.315.6.483.282Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.252 16.455a8.888 8.888 0 0 1 4.175-3.931c.139-.063.172-.261.1-.382-.082-.142-.243-.164-.382-.1a9.378 9.378 0 0 0-4.376 4.131c-.168.318.315.6.483.282Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.252 16.455a8.888 8.888 0 0 1 4.175-3.931c.139-.063.172-.261.1-.382-.082-.142-.243-.164-.382-.1a9.378 9.378 0 0 0-4.376 4.131c-.168.318.315.6.483.282Z",
    stroke: "#fff",
    strokeWidth: 0.6,
    mask: "url(#RewardsAll_svg__c)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__d",
    maskUnits: "userSpaceOnUse",
    x: 10.732,
    y: 23.41,
    width: 7,
    height: 6,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.732 23.41h7v6h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.426 28.483a8.889 8.889 0 0 1-4.176-3.933c-.168-.319-.65-.036-.482.282a9.378 9.378 0 0 0 4.376 4.133c.139.064.3.041.382-.1.071-.121.039-.319-.1-.382Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.426 28.483a8.889 8.889 0 0 1-4.176-3.933c-.168-.319-.65-.036-.482.282a9.378 9.378 0 0 0 4.376 4.133c.139.064.3.041.382-.1.071-.121.039-.319-.1-.382Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.426 28.483a8.889 8.889 0 0 1-4.176-3.933c-.168-.319-.65-.036-.482.282a9.378 9.378 0 0 0 4.376 4.133c.139.064.3.041.382-.1.071-.121.039-.319-.1-.382Z",
    stroke: "#fff",
    strokeWidth: 0.6,
    mask: "url(#RewardsAll_svg__d)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__e",
    maskUnits: "userSpaceOnUse",
    x: 22.43,
    y: 11.004,
    width: 7,
    height: 6,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.43 11.004h7v6h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.566 12.52a8.888 8.888 0 0 1 4.182 3.934c.168.319.65.036.482-.282a9.377 9.377 0 0 0-4.382-4.135c-.138-.063-.3-.04-.382.1-.07.122-.038.32.1.383Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.566 12.52a8.888 8.888 0 0 1 4.182 3.934c.168.319.65.036.482-.282a9.377 9.377 0 0 0-4.382-4.135c-.138-.063-.3-.04-.382.1-.07.122-.038.32.1.383Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.566 12.52a8.888 8.888 0 0 1 4.182 3.934c.168.319.65.036.482-.282a9.377 9.377 0 0 0-4.382-4.135c-.138-.063-.3-.04-.382.1-.07.122-.038.32.1.383Z",
    stroke: "#fff",
    strokeWidth: 0.6,
    mask: "url(#RewardsAll_svg__e)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__f",
    maskUnits: "userSpaceOnUse",
    x: 22.43,
    y: 23.414,
    width: 7,
    height: 6,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.43 23.414h7v6h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.748 24.554a8.887 8.887 0 0 1-4.182 3.935c-.138.063-.17.261-.1.383.083.14.244.163.382.1a9.377 9.377 0 0 0 4.383-4.136c.168-.318-.314-.6-.483-.282Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.748 24.554a8.887 8.887 0 0 1-4.182 3.935c-.138.063-.17.261-.1.383.083.14.244.163.382.1a9.377 9.377 0 0 0 4.383-4.136c.168-.318-.314-.6-.483-.282Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.748 24.554a8.887 8.887 0 0 1-4.182 3.935c-.138.063-.17.261-.1.383.083.14.244.163.382.1a9.377 9.377 0 0 0 4.383-4.136c.168-.318-.314-.6-.483-.282Z",
    stroke: "#fff",
    strokeWidth: 0.6,
    mask: "url(#RewardsAll_svg__f)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__g",
    maskUnits: "userSpaceOnUse",
    x: 17.459,
    y: 7.578,
    width: 5,
    height: 5,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.459 7.578h5v5h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.983 10.124a.994.994 0 0 1-.983.984c-.543.008-.977-.453-.984-.984-.008-.543.453-.976.984-.984.543-.007.976.453.983.984.005.36.564.36.56 0a1.57 1.57 0 0 0-1.077-1.47c-.646-.222-1.343.062-1.735.595-.401.543-.34 1.317.064 1.835a1.548 1.548 0 0 0 1.738.487c.605-.226 1-.804 1.01-1.447.004-.36-.555-.36-.56 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.983 10.124a.994.994 0 0 1-.983.984c-.543.008-.977-.453-.984-.984-.008-.543.453-.976.984-.984.543-.007.976.453.983.984.005.36.564.36.56 0a1.57 1.57 0 0 0-1.077-1.47c-.646-.222-1.343.062-1.735.595-.401.543-.34 1.317.064 1.835a1.548 1.548 0 0 0 1.738.487c.605-.226 1-.804 1.01-1.447.004-.36-.555-.36-.56 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 11.108-.005-.3.005.3Zm-.984-.984-.3.005.3-.005ZM20 9.14l-.005-.3.005.3Zm1.542.984.3-.004-.3.004Zm-1.076-1.47-.097.284.097-.284Zm-1.735.595.241.178-.241-.178Zm.064 1.835.236-.184-.236.184Zm1.738.487.105.28-.105-.28Zm1.01-1.447-.3-.004.3.004Zm-.56 0-.163.252.456.296.007-.544-.3-.004Zm-.3-.004a.694.694 0 0 1-.688.688l.009.6a1.294 1.294 0 0 0 1.28-1.28l-.6-.008Zm-.688.688c-.364.005-.674-.309-.68-.688l-.6.009c.01.683.567 1.29 1.289 1.279l-.009-.6Zm-.68-.688c-.005-.364.31-.674.689-.68l-.009-.6c-.683.01-1.29.566-1.28 1.289l.6-.01Zm.689-.68c.364-.005.674.31.68.689l.6-.01c-.01-.682-.567-1.289-1.289-1.279l.009.6Zm.68.689a.56.56 0 0 0 .195.426.6.6 0 0 0 .387.14.591.591 0 0 0 .389-.142.553.553 0 0 0 .187-.433l-.6.009c0 .005 0 .002.003-.007a.064.064 0 0 1 .016-.021c.005-.005.01-.007.01-.007h-.01l.007.004c.005.004.01.01.013.017.003.008.002.01.002.005l-.6.009Zm1.158-.01a1.87 1.87 0 0 0-1.278-1.749l-.195.568c.52.178.865.644.873 1.19l.6-.008ZM20.564 8.37c-.791-.27-1.618.08-2.075.7l.483.357c.328-.445.894-.661 1.397-.49l.195-.567Zm-2.075.7c-.49.666-.407 1.588.07 2.2l.473-.37c-.333-.426-.37-1.052-.06-1.473l-.483-.356Zm.07 2.2c.484.62 1.346.856 2.079.582l-.21-.562a1.248 1.248 0 0 1-1.396-.39l-.474.37Zm2.079.582a1.863 1.863 0 0 0 1.204-1.723l-.6-.009a1.263 1.263 0 0 1-.814 1.17l.21.562Zm1.204-1.723a.553.553 0 0 0-.187-.434.59.59 0 0 0-.389-.141.6.6 0 0 0-.387.139.561.561 0 0 0-.196.427l.6.008c0-.005.001-.002-.002.005a.051.051 0 0 1-.013.017l-.007.005.006-.001h.004s-.005-.001-.01-.006a.063.063 0 0 1-.016-.022c-.004-.008-.003-.012-.003-.006l.6.009Zm-.695-.256-.327.503.327-.503Z",
    fill: "#fff",
    mask: "url(#RewardsAll_svg__g)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__h",
    maskUnits: "userSpaceOnUse",
    x: 16.445,
    y: 10.078,
    width: 7,
    height: 5,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.445 10.078h7v5h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.407 11.607c.245.16.43.395.523.673.061.18.065.362.065.55v.615c0 .116.022.285-.023.374-.05.097-.13.113-.235.113h-3.481c-.12 0-.187-.032-.244-.144-.036-.07-.008-.272-.008-.367 0-.384-.047-.805.076-1.174.086-.258.276-.484.5-.632.3-.198.02-.682-.281-.483a1.875 1.875 0 0 0-.854 1.58v1.003c0 .327.209.628.52.734.11.037.223.042.337.042h3.467c.26 0 .499-.12.648-.333.124-.178.136-.376.136-.583v-.615c0-.268 0-.53-.072-.791a1.863 1.863 0 0 0-.793-1.045c-.303-.197-.582.288-.281.483Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.407 11.607c.245.16.43.395.523.673.061.18.065.362.065.55v.615c0 .116.022.285-.023.374-.05.097-.13.113-.235.113h-3.481c-.12 0-.187-.032-.244-.144-.036-.07-.008-.272-.008-.367 0-.384-.047-.805.076-1.174.086-.258.276-.484.5-.632.3-.198.02-.682-.281-.483a1.875 1.875 0 0 0-.854 1.58v1.003c0 .327.209.628.52.734.11.037.223.042.337.042h3.467c.26 0 .499-.12.648-.333.124-.178.136-.376.136-.583v-.615c0-.268 0-.53-.072-.791a1.863 1.863 0 0 0-.793-1.045c-.303-.197-.582.288-.281.483Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.407 11.607c.245.16.43.395.523.673.061.18.065.362.065.55v.615c0 .116.022.285-.023.374-.05.097-.13.113-.235.113h-3.481c-.12 0-.187-.032-.244-.144-.036-.07-.008-.272-.008-.367 0-.384-.047-.805.076-1.174.086-.258.276-.484.5-.632.3-.198.02-.682-.281-.483a1.875 1.875 0 0 0-.854 1.58v1.003c0 .327.209.628.52.734.11.037.223.042.337.042h3.467c.26 0 .499-.12.648-.333.124-.178.136-.376.136-.583v-.615c0-.268 0-.53-.072-.791a1.863 1.863 0 0 0-.793-1.045c-.303-.197-.582.288-.281.483Z",
    stroke: "#fff",
    strokeWidth: 0.6,
    mask: "url(#RewardsAll_svg__h)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__i",
    maskUnits: "userSpaceOnUse",
    x: 17.459,
    y: 25.512,
    width: 5,
    height: 5,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.459 25.512h5v5h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.983 28.058a.994.994 0 0 1-.983.983c-.543.008-.977-.452-.984-.983-.008-.543.453-.976.984-.984.543-.008.976.452.983.984.005.36.564.36.56 0a1.57 1.57 0 0 0-1.077-1.47c-.646-.222-1.343.062-1.735.594-.401.544-.34 1.318.064 1.836a1.548 1.548 0 0 0 1.738.486c.605-.226 1-.803 1.01-1.446.004-.36-.555-.36-.56 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.983 28.058a.994.994 0 0 1-.983.983c-.543.008-.977-.452-.984-.983-.008-.543.453-.976.984-.984.543-.008.976.452.983.984.005.36.564.36.56 0a1.57 1.57 0 0 0-1.077-1.47c-.646-.222-1.343.062-1.735.594-.401.544-.34 1.318.064 1.836a1.548 1.548 0 0 0 1.738.486c.605-.226 1-.803 1.01-1.446.004-.36-.555-.36-.56 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 29.041-.005-.3.005.3Zm-.984-.983-.3.004.3-.004Zm.984-.984-.005-.3.005.3Zm1.542.984.3-.005-.3.005Zm-1.076-1.47-.097.283.097-.284Zm-1.735.594.241.178-.241-.178Zm.064 1.836.236-.184-.236.184Zm1.738.486.105.281-.105-.28Zm1.01-1.446-.3-.005.3.005Zm-.56 0-.172.245.464.325.008-.566-.3-.004Zm-.3-.005a.694.694 0 0 1-.688.689l.009.6a1.294 1.294 0 0 0 1.28-1.28l-.6-.009Zm-.688.689c-.364.005-.674-.31-.68-.689l-.6.01c.01.682.567 1.289 1.289 1.279l-.009-.6Zm-.68-.689c-.005-.364.31-.674.689-.679l-.009-.6c-.683.01-1.29.566-1.28 1.288l.6-.009Zm.689-.679c.364-.005.674.309.68.688l.6-.009c-.01-.683-.567-1.29-1.289-1.279l.009.6Zm.68.688a.561.561 0 0 0 .195.427.6.6 0 0 0 .387.139.591.591 0 0 0 .389-.141.553.553 0 0 0 .187-.433l-.6.008c0 .006 0 .002.003-.006a.064.064 0 0 1 .016-.022c.005-.005.01-.006.01-.006h-.01l.007.004c.005.004.01.01.013.017.003.007.002.01.002.005l-.6.008Zm1.158-.009a1.87 1.87 0 0 0-1.278-1.75l-.195.568c.52.178.865.645.873 1.191l.6-.009Zm-1.278-1.75c-.791-.27-1.618.081-2.075.701l.483.356c.328-.445.894-.66 1.397-.489l.195-.567Zm-2.075.701c-.49.665-.407 1.588.07 2.199l.473-.37c-.333-.426-.37-1.051-.06-1.473l-.483-.356Zm.07 2.199c.484.62 1.346.857 2.079.582l-.21-.561a1.248 1.248 0 0 1-1.396-.39l-.474.369Zm2.079.582a1.863 1.863 0 0 0 1.204-1.723l-.6-.008a1.263 1.263 0 0 1-.814 1.17l.21.561Zm1.204-1.723a.553.553 0 0 0-.187-.433.59.59 0 0 0-.389-.141.6.6 0 0 0-.387.139.561.561 0 0 0-.196.427l.6.008c0-.005.001-.003-.002.005a.051.051 0 0 1-.013.017l-.007.004h.01s-.005-.002-.01-.007a.063.063 0 0 1-.016-.021c-.004-.009-.003-.012-.003-.006l.6.008Zm-.687-.25-.344.491.344-.491Z",
    fill: "#fff",
    mask: "url(#RewardsAll_svg__i)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__j",
    maskUnits: "userSpaceOnUse",
    x: 16.445,
    y: 28.008,
    width: 7,
    height: 5,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.445 28.008h7v5h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.407 29.537c.245.159.43.394.523.672.061.181.065.363.065.55v.616c0 .116.022.285-.023.373-.05.097-.13.114-.235.114h-3.481c-.12 0-.187-.032-.244-.144-.036-.07-.008-.273-.008-.367 0-.384-.047-.805.076-1.175a1.26 1.26 0 0 1 .5-.632c.3-.197.02-.682-.281-.482a1.875 1.875 0 0 0-.854 1.58v1.003c0 .327.209.627.52.733.11.038.223.042.337.042h3.467c.26 0 .499-.12.648-.333.124-.177.136-.376.136-.583v-.615c0-.268 0-.53-.072-.79a1.863 1.863 0 0 0-.793-1.045c-.303-.197-.582.287-.281.482Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.407 29.537c.245.159.43.394.523.672.061.181.065.363.065.55v.616c0 .116.022.285-.023.373-.05.097-.13.114-.235.114h-3.481c-.12 0-.187-.032-.244-.144-.036-.07-.008-.273-.008-.367 0-.384-.047-.805.076-1.175a1.26 1.26 0 0 1 .5-.632c.3-.197.02-.682-.281-.482a1.875 1.875 0 0 0-.854 1.58v1.003c0 .327.209.627.52.733.11.038.223.042.337.042h3.467c.26 0 .499-.12.648-.333.124-.177.136-.376.136-.583v-.615c0-.268 0-.53-.072-.79a1.863 1.863 0 0 0-.793-1.045c-.303-.197-.582.287-.281.482Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.407 29.537c.245.159.43.394.523.672.061.181.065.363.065.55v.616c0 .116.022.285-.023.373-.05.097-.13.114-.235.114h-3.481c-.12 0-.187-.032-.244-.144-.036-.07-.008-.273-.008-.367 0-.384-.047-.805.076-1.175a1.26 1.26 0 0 1 .5-.632c.3-.197.02-.682-.281-.482a1.875 1.875 0 0 0-.854 1.58v1.003c0 .327.209.627.52.733.11.038.223.042.337.042h3.467c.26 0 .499-.12.648-.333.124-.177.136-.376.136-.583v-.615c0-.268 0-.53-.072-.79a1.863 1.863 0 0 0-.793-1.045c-.303-.197-.582.287-.281.482Z",
    stroke: "#fff",
    strokeWidth: 0.6,
    mask: "url(#RewardsAll_svg__j)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__k",
    maskUnits: "userSpaceOnUse",
    x: 26.906,
    y: 16.547,
    width: 5,
    height: 5,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.906 16.547h5v5h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.43 19.093a.994.994 0 0 1-.983.984c-.543.007-.976-.453-.984-.984-.008-.543.453-.976.984-.984.543-.008.976.453.984.984.005.36.563.36.558 0a1.57 1.57 0 0 0-1.075-1.47c-.647-.222-1.344.062-1.736.594-.4.544-.34 1.318.064 1.836a1.548 1.548 0 0 0 1.738.487c.605-.227 1-.804 1.01-1.447.005-.36-.554-.36-.56 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.43 19.093a.994.994 0 0 1-.983.984c-.543.007-.976-.453-.984-.984-.008-.543.453-.976.984-.984.543-.008.976.453.984.984.005.36.563.36.558 0a1.57 1.57 0 0 0-1.075-1.47c-.647-.222-1.344.062-1.736.594-.4.544-.34 1.318.064 1.836a1.548 1.548 0 0 0 1.738.487c.605-.227 1-.804 1.01-1.447.005-.36-.554-.36-.56 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.447 20.077-.005-.3.005.3Zm-.984-.984-.3.004.3-.004Zm.984-.984-.005-.3.005.3Zm1.542.984.3-.004-.3.004Zm-1.075-1.47-.098.283.098-.283Zm-1.736.594.241.178-.241-.178Zm.064 1.836.237-.184-.237.184Zm1.738.487.105.28-.105-.28Zm1.01-1.447-.3-.004.3.004Zm-.56 0-.163.252.456.296.008-.544-.3-.004Zm-.3-.004a.694.694 0 0 1-.688.688l.01.6a1.294 1.294 0 0 0 1.278-1.28l-.6-.008Zm-.688.688c-.364.005-.674-.31-.679-.688l-.6.008c.01.683.566 1.29 1.288 1.28l-.009-.6Zm-.679-.688c-.005-.364.31-.674.688-.68l-.009-.6c-.683.01-1.29.566-1.279 1.288l.6-.008Zm.688-.68c.364-.005.674.31.68.688l.6-.008c-.01-.683-.567-1.29-1.289-1.28l.01.6Zm.68.688a.56.56 0 0 0 .196.427.598.598 0 0 0 .387.14.59.59 0 0 0 .388-.142.553.553 0 0 0 .187-.433l-.6.008c0 .006 0 .002.003-.006a.062.062 0 0 1 .016-.022c.006-.005.01-.006.01-.006h-.004a.02.02 0 0 1-.006 0s.003 0 .007.004c.005.004.01.01.013.017l.002.005-.6.008Zm1.158-.008a1.87 1.87 0 0 0-1.278-1.75l-.195.567c.52.178.866.645.873 1.191l.6-.008Zm-1.278-1.75c-.79-.27-1.618.08-2.075.7l.483.356c.328-.445.895-.66 1.397-.489l.195-.567Zm-2.075.7c-.49.666-.407 1.588.07 2.199l.473-.37c-.333-.425-.37-1.05-.06-1.473l-.483-.356Zm.07 2.199c.484.62 1.346.857 2.08.583l-.21-.562a1.248 1.248 0 0 1-1.397-.39l-.473.369Zm2.08.583a1.863 1.863 0 0 0 1.203-1.724l-.6-.008a1.263 1.263 0 0 1-.814 1.17l.21.562Zm1.203-1.724a.553.553 0 0 0-.187-.433.59.59 0 0 0-.388-.141.6.6 0 0 0-.387.139.561.561 0 0 0-.196.427l.6.008c0-.005 0-.003-.003.005a.054.054 0 0 1-.013.017l-.007.005.006-.001h.004l-.01-.007a.062.062 0 0 1-.016-.021c-.003-.008-.003-.012-.003-.006l.6.009Zm-.695-.256-.327.503.327-.503Z",
    fill: "#fff",
    mask: "url(#RewardsAll_svg__k)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__l",
    maskUnits: "userSpaceOnUse",
    x: 25.893,
    y: 19.047,
    width: 7,
    height: 5,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.893 19.047h7v5h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.854 20.575c.245.16.43.395.524.673.06.181.064.363.064.55v.616c0 .116.022.285-.023.373-.049.097-.13.114-.235.114h-3.481c-.12 0-.187-.032-.244-.145-.036-.07-.008-.272-.008-.366 0-.384-.047-.806.076-1.175.086-.258.276-.483.5-.632.3-.197.02-.682-.281-.482a1.875 1.875 0 0 0-.853 1.58v1.003c0 .327.208.627.519.733.11.038.223.042.337.042h3.468c.259 0 .498-.12.647-.332.125-.178.137-.377.137-.583v-.616c0-.268 0-.53-.073-.79a1.863 1.863 0 0 0-.792-1.045c-.303-.197-.583.287-.282.482Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.854 20.575c.245.16.43.395.524.673.06.181.064.363.064.55v.616c0 .116.022.285-.023.373-.049.097-.13.114-.235.114h-3.481c-.12 0-.187-.032-.244-.145-.036-.07-.008-.272-.008-.366 0-.384-.047-.806.076-1.175.086-.258.276-.483.5-.632.3-.197.02-.682-.281-.482a1.875 1.875 0 0 0-.853 1.58v1.003c0 .327.208.627.519.733.11.038.223.042.337.042h3.468c.259 0 .498-.12.647-.332.125-.178.137-.377.137-.583v-.616c0-.268 0-.53-.073-.79a1.863 1.863 0 0 0-.792-1.045c-.303-.197-.583.287-.282.482Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.854 20.575c.245.16.43.395.524.673.06.181.064.363.064.55v.616c0 .116.022.285-.023.373-.049.097-.13.114-.235.114h-3.481c-.12 0-.187-.032-.244-.145-.036-.07-.008-.272-.008-.366 0-.384-.047-.806.076-1.175.086-.258.276-.483.5-.632.3-.197.02-.682-.281-.482a1.875 1.875 0 0 0-.853 1.58v1.003c0 .327.208.627.519.733.11.038.223.042.337.042h3.468c.259 0 .498-.12.647-.332.125-.178.137-.377.137-.583v-.616c0-.268 0-.53-.073-.79a1.863 1.863 0 0 0-.792-1.045c-.303-.197-.583.287-.282.482Z",
    stroke: "#fff",
    strokeWidth: 0.6,
    mask: "url(#RewardsAll_svg__l)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__m",
    maskUnits: "userSpaceOnUse",
    x: 8.014,
    y: 16.547,
    width: 5,
    height: 5,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.014 16.547h5v5h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.538 19.093a.994.994 0 0 1-.984.984c-.543.007-.976-.453-.984-.984-.007-.543.453-.976.984-.984.543-.008.976.453.984.984.005.36.564.36.559 0a1.57 1.57 0 0 0-1.076-1.47c-.647-.222-1.343.062-1.736.594-.4.544-.34 1.318.065 1.836a1.548 1.548 0 0 0 1.738.487c.604-.227 1-.804 1.009-1.447.005-.36-.554-.36-.559 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.538 19.093a.994.994 0 0 1-.984.984c-.543.007-.976-.453-.984-.984-.007-.543.453-.976.984-.984.543-.008.976.453.984.984.005.36.564.36.559 0a1.57 1.57 0 0 0-1.076-1.47c-.647-.222-1.343.062-1.736.594-.4.544-.34 1.318.065 1.836a1.548 1.548 0 0 0 1.738.487c.604-.227 1-.804 1.009-1.447.005-.36-.554-.36-.559 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.554 20.077-.004-.3.004.3Zm-.984-.984-.3.004.3-.004Zm.984-.984-.004-.3.004.3Zm1.543.984.3-.004-.3.004Zm-1.076-1.47-.097.283.097-.283Zm-1.736.594.242.178-.242-.178Zm.065 1.836.236-.184-.236.184Zm1.738.487.105.28-.105-.28Zm1.009-1.447.3.005-.3-.005Zm-.559 0-.17.247.462.316.008-.559-.3-.004Zm-.3-.004a.694.694 0 0 1-.688.688l.008.6a1.295 1.295 0 0 0 1.28-1.28l-.6-.008Zm-.688.688c-.364.005-.674-.31-.68-.688l-.6.008c.01.683.567 1.29 1.289 1.28l-.01-.6Zm-.68-.688c-.005-.364.31-.674.689-.68l-.01-.6c-.682.01-1.289.566-1.278 1.288l.6-.008Zm.689-.68c.364-.005.674.31.679.688l.6-.008c-.01-.683-.566-1.29-1.288-1.28l.008.6Zm.679.688a.56.56 0 0 0 .196.427.598.598 0 0 0 .387.14.591.591 0 0 0 .388-.142.554.554 0 0 0 .188-.433l-.6.008c0 .006-.001.002.003-.006a.063.063 0 0 1 .015-.022c.006-.005.01-.006.01-.006h-.004a.02.02 0 0 1-.005 0s.002 0 .006.004c.005.004.01.01.014.017.003.007.002.01.002.005l-.6.008Zm1.159-.009a1.87 1.87 0 0 0-1.279-1.75l-.194.568c.52.178.865.645.873 1.191l.6-.009Zm-1.279-1.75c-.79-.27-1.617.081-2.074.701l.483.356c.328-.445.894-.66 1.397-.489l.194-.567Zm-2.074.701c-.49.666-.408 1.588.07 2.199l.472-.37c-.332-.425-.37-1.05-.06-1.473l-.482-.356Zm.07 2.199c.483.62 1.346.857 2.079.583l-.21-.562a1.248 1.248 0 0 1-1.397-.39l-.473.369Zm2.079.583a1.863 1.863 0 0 0 1.204-1.724l-.6-.008a1.263 1.263 0 0 1-.815 1.17l.21.562Zm1.204-1.724a.554.554 0 0 0-.188-.433.59.59 0 0 0-.388-.141.599.599 0 0 0-.387.139.561.561 0 0 0-.196.427l.6.008c0-.005 0-.003-.002.005a.051.051 0 0 1-.014.017l-.006.005.005-.001h.005l-.01-.006a.062.062 0 0 1-.016-.022c-.004-.008-.003-.012-.003-.006l.6.008Zm-.69-.252-.338.495.338-.495Z",
    fill: "#fff",
    mask: "url(#RewardsAll_svg__m)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsAll_svg__n",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 19.047,
    width: 7,
    height: 5,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 19.047h7v5H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.961 20.575c.246.16.43.395.524.673.061.181.065.363.065.55v.616c0 .116.022.285-.023.373-.05.097-.131.114-.236.114H8.81c-.119 0-.187-.032-.244-.145-.035-.07-.007-.272-.007-.366 0-.384-.047-.806.075-1.175.086-.258.276-.483.501-.632.3-.197.02-.682-.282-.482A1.875 1.875 0 0 0 8 21.68v1.003c0 .327.208.627.52.733.11.038.222.042.337.042H12.324c.26 0 .498-.12.648-.332.124-.178.136-.377.136-.583v-.616c0-.268 0-.53-.073-.79a1.863 1.863 0 0 0-.792-1.045c-.303-.197-.583.287-.282.482Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.961 20.575c.246.16.43.395.524.673.061.181.065.363.065.55v.616c0 .116.022.285-.023.373-.05.097-.131.114-.236.114H8.81c-.119 0-.187-.032-.244-.145-.035-.07-.007-.272-.007-.366 0-.384-.047-.806.075-1.175.086-.258.276-.483.501-.632.3-.197.02-.682-.282-.482A1.875 1.875 0 0 0 8 21.68v1.003c0 .327.208.627.52.733.11.038.222.042.337.042H12.324c.26 0 .498-.12.648-.332.124-.178.136-.377.136-.583v-.616c0-.268 0-.53-.073-.79a1.863 1.863 0 0 0-.792-1.045c-.303-.197-.583.287-.282.482Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.961 20.575c.246.16.43.395.524.673.061.181.065.363.065.55v.616c0 .116.022.285-.023.373-.05.097-.131.114-.236.114H8.81c-.119 0-.187-.032-.244-.145-.035-.07-.007-.272-.007-.366 0-.384-.047-.806.075-1.175.086-.258.276-.483.501-.632.3-.197.02-.682-.282-.482A1.875 1.875 0 0 0 8 21.68v1.003c0 .327.208.627.52.733.11.038.222.042.337.042H12.324c.26 0 .498-.12.648-.332.124-.178.136-.377.136-.583v-.616c0-.268 0-.53-.073-.79a1.863 1.863 0 0 0-.792-1.045c-.303-.197-.583.287-.282.482Z",
    stroke: "#fff",
    strokeWidth: 0.6,
    mask: "url(#RewardsAll_svg__n)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -32,
    width: 377,
    height: 286,
    rx: 8,
    stroke: "#03C8B0",
    strokeWidth: 4,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "RewardsAll_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-1003 -731)",
    d: "M0 0h1440v3954H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "RewardsAll_svg__b",
    x: -32,
    y: -34,
    width: 385,
    height: 294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0117647 0 0 0 0 0.784314 0 0 0 0 0.690196 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13219_804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_13219_804",
    result: "shape"
  })))));
};

export default SvgRewardsAll;